export const MUTATION_TYPES = {
  RESET: 'reset',
  SET_ACADEMIC_YEARS: 'setAcademicYears',
  SET_MONTHS: 'setMonths',
  SET_SPECIALIST: 'setSpecialsts',
  SET_CENTERS: 'setCenters',
  SET_PROVIDERS: 'setProviders',
  SET_STATUS: 'setStatus',
  SET_CLEAR_CATALOG: 'setClearCatalog',
  SET_RESULT: 'setResult',
  SET_RESULT_SPECIALIST_INFO: 'setResultSpecialistInfo',
  SET_ADDITIONAL_INFO: 'setAdditionalInfo',
  SET_SERVICES: 'setServices',
};

export const ACTION_TYPES = {
  RESET: 'reset',
  GET_ACADEMIC_YEARS: 'getAcademicYears',
  GET_MONTHS: 'getMonths',
  GET_SPECIALIST: 'getSpecialist',
  GET_PERIOD_END_SUMMARY: 'getResult',
  FINALIZE_PERIOD: 'finalizePeriod',
  START_ENDED_PERIOD: 'startEndedPeriod',
  GET_CENTERS: 'getCenters',
  Get_PROVIDERS: 'getProviders',
  GET_SPECIALIST2: 'getSpecialist2',
  GET_SERVICES: 'getServices',
};
